import React from 'react';
import styles from './styles';
import LinkIcons from './LinkIcons';
import linkCopy from './linkCopy';
import {ResponsiveContext} from '../../Context/ResponsiveContext';

const Descriptions = props => {

  const {device} = React.useContext(ResponsiveContext);
  const heights = {
    mobile: 'auto',
    tablet: '200px',
    desktop: '200px',
    xlScreen: '185px'
  }
  const column = device === 'tablet' ? 'oneHalf' : 'oneThird';

  return(
    <div style={styles.clearfix}>
      {props.links.map((id, i) => <div key={id} style={{
          ...props.columns[column],
          ...styles.descriptionBox,
          minHeight: heights[device],
        }}>
          <h5 style={{...styles.subTitle, ...styles.descriptionTitle}}>
            <LinkIcons name={id} size='md' />{props.tabSettings[id].title}
          </h5>
          {linkCopy[id].map((p, i) => <p key={i} style={styles.copy}>{p}</p>)}
        </div>
      )}
    </div>
  )
}

export default Descriptions;
